import React, { useRef, useState } from 'react';

import styled from 'styled-components';

import ConfirmModal from 'common/Modal/ConfirmModal';

const StyledConfirmModal = styled(ConfirmModal)`
  &&& .ant-modal-content: {
    width: 540px;
  }
`;

type Props = {
  showCommunityIncentivesConfirmationModal: boolean;
  communityName: string | undefined;
  loading?: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
};

const CommunityInfoConfirmationModal = ({
  showCommunityIncentivesConfirmationModal,
  communityName,
  loading,
  onConfirm,
  onClose,
}: Props) => {
  const isSubmittingRef = useRef(false);
  const [submitting, setSubmitting] = useState(false);
  const busy = Boolean(loading || submitting);

  const handleConfirm = async () => {
    if (busy || isSubmittingRef.current) return;

    isSubmittingRef.current = true;
    setSubmitting(true);
    try {
      await onConfirm();
    } finally {
      isSubmittingRef.current = false;
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    if (busy || isSubmittingRef.current) return;
    onClose();
  };

  return (
    <StyledConfirmModal
      open={Boolean(showCommunityIncentivesConfirmationModal)}
      title={<span data-test-id="cd-community-info-confirmation-modal-title">Data Propagation Notice?</span>}
      subtitle={communityName}
      loading={busy}
      closable={!busy}
      maskClosable={!busy}
      keyboard={!busy}
      description={
        'You are about to save system-level changes that will affect displayed data for multiple companies and communities. Are you sure you want to do this?'
      }
      confirmLabel={'Confirm & Save'}
      checkboxConfirmLabel={'I understand that this will affect other companies and communities'}
      confirmButtonDataTestId="cd-community-info-confirmation-modal-confirm"
      cancelButtonDataTestId="cd-community-info-confirmation-modal-cancel"
      onConfirm={handleConfirm}
      onCancel={handleClose}
    />
  );
};

export default CommunityInfoConfirmationModal;
